import { RouteUrlList } from '@/libs/RouteList';
const IdleTimeout = [
    'POST',
    RouteUrlList.API_IdleTimeout.path,
    {},
    200,
    {
        status: true,
        title: '',
        message: '',
        errorCode: ''
    }
];
export default IdleTimeout;
